// PLUGINS IMPORTS //
import React, { memo } from "react"
import styled from "styled-components/macro"

// COMPONENTS IMPORTS //
import { memoComparison } from "Content/Shared/Helpers/Functions/Functions"

// EXTRA IMPORTS //
import { iPhoneResolution } from "Content/Shared/Styles/Theme"

/////////////////////////////////////////////////////////////////////////////

type PropsType = {
  video: any
  style?: any
}

const Video: React.FC<PropsType> = (props) => {
  return (
    <VideoStyle
      src={props.video}
      autoPlay
      height={630}
      width={330}
      style={{}}
      loop
      muted
    />
  )
}

/////////////////////////////////////////////////////////////////////////////

const VideoStyle = styled.video`
  border-radius: 73px;

  @media (max-width: ${iPhoneResolution}px) {
    border-radius: 110px;
  }
`

export default memo(Video, memoComparison)
